import { Route, Routes } from "react-router-dom";
import { PlayPronosticsV2Presenter } from "pronosticsv2/play/views/PlayPronosticsV2Presenter";
import { PronosticsV2ThemeWrapper } from "pronosticsv2/layouts/PronosticsV2ThemeWrapper";

//HTMLThemeWrapper

export function PronosticsV2Routes() {
  return (
    <Routes>
      <Route path="" element={<PronosticsV2ThemeWrapper />}>
        <Route path="" element={<PlayPronosticsV2Presenter />} />
      </Route>
      <Route path=":pronosticsV2Id" element={<PronosticsV2ThemeWrapper />}>
        <Route path="" element={<PlayPronosticsV2Presenter />}></Route>
      </Route>
    </Routes>
  );
}
